import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SimpleUserFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M17.0647 15.2193C17.6348 15.5276 18.5292 16.0112 19.1409 16.5857C19.5219 16.9435 19.9159 17.4428 19.9883 18.0778C20.0665 18.7649 19.7485 19.3852 19.1772 19.9074C18.2182 20.784 17.0522 21.4996 15.5399 21.4996H8.46015C6.94779 21.4996 5.78177 20.784 4.8228 19.9074C4.25148 19.3852 3.93346 18.7649 4.01174 18.0778C4.08408 17.4428 4.47813 16.9435 4.85906 16.5857C5.47085 16.0112 6.36511 15.5276 6.93523 15.2193C7.06216 15.1507 7.17304 15.0907 7.26114 15.0404C10.1634 13.3824 13.8366 13.3824 16.7389 15.0404C16.8269 15.0907 16.9378 15.1507 17.0647 15.2193Z"
				fill="currentColor"
			/>
			<path
				d="M7.09375 7.37838C7.09375 4.68412 9.28894 2.5 11.9968 2.5C14.7048 2.5 16.9 4.68412 16.9 7.37838C16.9 10.0726 14.7048 12.2568 11.9968 12.2568C9.28894 12.2568 7.09375 10.0726 7.09375 7.37838Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SimpleUserFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SimpleUserFilledIcon;
